import * as React from 'react';

import { cn } from '../../lib/cn';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../tooltip';

export interface PermissionTripleProps extends React.HTMLAttributes<HTMLSpanElement> {
  module: string;
  action: string;
  scope: string;
  description?: string;
}

export const PermissionTriple = React.forwardRef<HTMLSpanElement, PermissionTripleProps>(
  ({ className, module, action, scope, description, ...props }, ref) => {
    const triple = (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center gap-1 font-mono text-[11px]',
          'rounded-[var(--radius-sm)] bg-[var(--color-subtle)] px-1.5 py-0.5',
          'text-[var(--color-fg-secondary)]',
          className,
        )}
        {...props}
      >
        <span className="text-[var(--color-accent)]">{module}</span>
        <span className="text-[var(--color-fg-muted)]">·</span>
        <span>{action}</span>
        <span className="text-[var(--color-fg-muted)]">·</span>
        <span className="text-[var(--color-fg-secondary)]">{scope}</span>
      </span>
    );
    if (!description) return triple;
    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>{triple}</TooltipTrigger>
          <TooltipContent className="max-w-xs">{description}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  },
);
PermissionTriple.displayName = 'PermissionTriple';
